"use strict";

class ModalTrapFocus {
    constructor(container, escCallBack, isTypeDropDown){
        if(!container) throw new Error('Invalid container or escCallBack');

        this.container = container;
        this.isTypeDropDown = isTypeDropDown;
        this.escCallBack = escCallBack;
        this.focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        this.focusableContent = this.container.querySelectorAll(this.focusableElements);
        this.firstFocusableElement = this.container.querySelectorAll(this.focusableElements)[0]; // get first element to be focused inside modal
        this.lastFocusableElement = this.focusableContent[this.focusableContent.length - 1]; // get last element to be focused inside modal

        this.init();
    }
    
    init(){
        if(!this.firstFocusableElement || !this.lastFocusableElement) return;
        const self = this;

        this.container.addEventListener('keydown', function(e) {
            const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
            const isEscKey = e.key === 'Escape';
            const isArrowUp = e.key === 'ArrowUp';
            const isArrowDown = e.key === 'ArrowDown';
            const isArrowLeft = e.key === 'ArrowLeft';
            const isArrowRight = e.key === 'ArrowRight';
            const target = e.target;
            const targetParentElement = target.parentElement;
            
            let prevElem = target.previousElementSibling;
            if(!prevElem && targetParentElement.childElementCount === 1 && targetParentElement.previousElementSibling) {
              prevElem = targetParentElement.previousElementSibling.querySelectorAll(self.focusableElements)[0];
            }

            let nextElem = target.nextElementSibling;
            if(!nextElem && targetParentElement.childElementCount === 1 && targetParentElement.nextElementSibling) {
              nextElem = targetParentElement.nextElementSibling.querySelectorAll(self.focusableElements)[0];
            }
            
            if(isEscKey){
              if(self.escCallBack && typeof self.escCallBack === "function") self.escCallBack.call(null, e);
              return;
            }

            if(self.isTypeDropDown){
              if (isTabPressed) {
                if(self.escCallBack && typeof self.escCallBack === "function") self.escCallBack.call(null, e);
                return;
              }

              if(isArrowUp || isArrowLeft){
                if(prevElem){
                  e.preventDefault();
                  prevElem.focus();
                }
              }
              if(isArrowDown || isArrowRight){
                if(nextElem){
                  e.preventDefault();
                  nextElem.focus();
                }
              }
            } else {
              if (!isTabPressed) {
                return;
              }

              if (e.shiftKey) { // if shift key pressed for shift + tab combination
                if (document.activeElement === self.firstFocusableElement) {
                  self.focusLastElement(); // add focus for the last focusable element
                  e.preventDefault();
                }
              } else { // if tab key is pressed
                if (document.activeElement === self.lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                  self.focusFirstElement(); // add focus for the first focusable element
                  e.preventDefault();
                }
              }
            }
        });
    }

    focusFirstElement(){
        if(!this.firstFocusableElement) return;
        this.firstFocusableElement.focus(); // add focus for the first focusable element
    }

    focusLastElement(){
        if(!this.lastFocusableElement) return;
        this.lastFocusableElement.focus(); // add focus for the last focusable element
    }
}